import { useAuthStore } from '../../../stores/authStore';
import { AvatarUploadControl } from '../../../components/feature/avatar';

interface Props {
  currentAvatar: string | null;
  displayName: string;
  onUploadSuccess: () => void;
}

/**
 * User profile avatar uploader.
 * Thin wrapper around the shared AvatarUploadControl:
 *   upload -> POST /uploads/avatar -> updateProfile({avatar})
 */
export default function AvatarUpload({ currentAvatar, displayName, onUploadSuccess }: Props) {
  const { user, updateProfile } = useAuthStore();

  const handleUploaded = async (url: string) => {
    if (!user) throw new Error('未登录');
    const { error } = await updateProfile({ avatar: url });
    if (error) throw error;
    onUploadSuccess();
  };

  return (
    <AvatarUploadControl
      name={displayName}
      avatarUrl={currentAvatar}
      onUploaded={handleUploaded}
      size="2xl"
      label="点击更换头像"
    />
  );
}
